import { Typography, Box, useTheme } from "@mui/material";
import { tokens } from "../theme";
import BreadcrumbsBar from "./BreadcrumbsBar";

const Header = ({ title, subtitle }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <div>
      {/* <Box m={3}>
        <Box
          marginLeft={{ xs: 1, md: 5 }}
          marginRight={{ xs: 1, md: 5 }}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography
            variant="h3"
            color={colors.grey[100]}
            fontWeight="bold"
            sx={{ mb: "15px" }}
          >
            {title}
          </Typography>
          <img
            alt="main-logo"
            src={`../../assets/icons/logo_text.png`}
            style={{
              cursor: "pointer",
              width: "70%",
              height: "auto",
              maxWidth: "300px",
            }}
          />
        </Box>
      </Box> */}
      <BreadcrumbsBar />
    </div>
  );
};

export default Header;
